module.exports = __webpack_public_path__ + "img/default.6c224806.jpg";